<template>
  <div>
    <nav class="header-contacts__social">
<!--      <a href="viber://pa?chatURI=dnipro_m_bot" class="header-contacts__social-item">-->
<!--        <span class="header-contacts__social-item__icon">-->
<!--          <svg-->
<!--            width="25"-->
<!--            height="25"-->
<!--            viewBox="0 0 25 25"-->
<!--            fill="none"-->
<!--            xmlns="http://www.w3.org/2000/svg"-->
<!--          >-->
<!--            <use :xlink:href="spritePath + '#header-viber'"></use>-->
<!--          </svg>-->
<!--          <svg-->
<!--            width="25"-->
<!--            height="25"-->
<!--            viewBox="0 0 25 25"-->
<!--            fill="none"-->
<!--            xmlns="http://www.w3.org/2000/svg"-->
<!--          >-->
<!--            <use :xlink:href="spritePath + '#header-viber-h'"></use>-->
<!--          </svg>-->
<!--        </span>-->
<!--        <span>Viber</span>-->
<!--      </a>-->
<!--      <a href="https://wa.me/380674146800" class="header-contacts__social-item">-->
<!--        <span class="header-contacts__social-item__icon">-->
<!--          <img class="header-contacts__social-item-img" src="/img/icons/social/whatsapp-gray.svg" alt="">-->
<!--          <img class="header-contacts__social-item-img h" src="/img/icons/social/whatsapp-red.svg" alt="">-->
<!--        </span>-->
<!--        <span>WhatsApp</span>-->
<!--      </a>-->
<!--      <a target="_blank" href="https://telegram.me/dnipro_m_bot" class="header-contacts__social-item">-->
<!--        <span class="header-contacts__social-item__icon">-->
<!--          <svg-->
<!--            width="25"-->
<!--            height="25"-->
<!--            viewBox="0 0 25 25"-->
<!--            fill="none"-->
<!--            xmlns="http://www.w3.org/2000/svg"-->
<!--          >-->
<!--            <use :xlink:href="spritePath + '#header-telegram'"></use>-->
<!--          </svg>-->
<!--          <svg-->
<!--            width="25"-->
<!--            height="25"-->
<!--            viewBox="0 0 25 25"-->
<!--            fill="none"-->
<!--            xmlns="http://www.w3.org/2000/svg"-->
<!--          >-->
<!--            <use :xlink:href="spritePath + '#header-telegram-h'"></use>-->
<!--          </svg>-->
<!--        </span>-->
<!--        <span>Telegram</span>-->
<!--      </a>-->
<!--      <a target="_blank" href="https://m.me/795514890478433" class="header-contacts__social-item">-->
<!--        <span class="header-contacts__social-item__icon">-->
<!--          <svg-->
<!--            width="25"-->
<!--            height="25"-->
<!--            viewBox="0 0 25 25"-->
<!--            fill="none"-->
<!--            xmlns="http://www.w3.org/2000/svg"-->
<!--          >-->
<!--            <use :xlink:href="spritePath + '#header-facebook'"></use>-->
<!--          </svg>-->
<!--          <svg-->
<!--            width="25"-->
<!--            height="25"-->
<!--            viewBox="0 0 25 25"-->
<!--            fill="none"-->
<!--            xmlns="http://www.w3.org/2000/svg"-->
<!--          >-->
<!--            <use :xlink:href="spritePath + '#header-facebook-h'"></use>-->
<!--          </svg>-->
<!--        </span>-->
<!--        <span>Facebook</span>-->
<!--      </a>-->
      <a href="mailto:kontakt@dnipro-m.pl" class="header-contacts__social-item">
        <span class="header-contacts__social-item__icon">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-email'"></use>
          </svg>
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-email-h'"></use>
          </svg>
        </span>
        <span>E-mail</span>
      </a>
      <a href="javascript:void(0)" @click="openChat()" class="header-contacts__social-item">
        <span class="header-contacts__social-item__icon">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-chat'"></use>
          </svg>
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-chat-h'"></use>
          </svg>
        </span>
        <span>{{ $t('header_sidebar_chat') }}</span>
      </a>
    </nav>
    <div class="header-contacts__phone-wrap">
      <a href="tel:+48698996611" class="header-contacts__social-item">
        <span class="header-contacts__social-item__icon">
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-phone'"></use>
          </svg>
          <svg
            width="25"
            height="25"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <use :xlink:href="spritePath + '#header-phone-h'"></use>
          </svg>
        </span>
        <span>48 698 99 66 11</span>
      </a>
      <div class="header-contacts__phone-info">{{ $t('footer_free_phone') }}</div>
    </div>
  </div>
</template>

<script>
import { spritePath } from '@/mixins/spritePath'
export default {
  mixins: [spritePath],
  name: 'HeaderContacts',
  methods: {
    openChat () {
      if (localStorage.getItem('zDChatStatus') === 'loaded' && this.$zendesk.isZe()) {
        this.$zendesk.open()
      } else {
        this.initChat()
      }
    },
    initChat () {
      this.$zendesk.load(process.env.VUE_APP_ZENDESK_KEY)
      if (localStorage.getItem('zDChatStatus') !== 'loaded') {
        let ttl = new Date()
        ttl.setHours(ttl.getHours() + 1)

        localStorage.setItem('zDChatStatusExpire', ttl.getTime())
        localStorage.setItem('zDChatStatus', 'loaded')
      }
    }
  },
  mounted () {
    const now = new Date()
    if (localStorage.getItem('zDChatStatusExpire') && localStorage.getItem('zDChatStatusExpire') < now.getTime()) {
      localStorage.removeItem('zDChatStatus')
      localStorage.removeItem('zDChatStatusExpire')
    }
    this.initChat()
  },
  created () {
    this.$zendesk.$on('loaded', () => {
      if (this.$zendesk.isZe()) {
        if (this.user && this.user.auth && this.user.user_data) {
          this.$zendesk.identify({
            name: (!this.user.user_data.name && !this.user.user_data.last_name) ? '' : this.user.user_data.name + ' ' + this.user.user_data.last_name,
            email: (this.user.user_data.email) ? this.user.user_data.email : '',
            phone: (this.user.user_data.phone) ? this.user.user_data.phone : ''
          })
        }

        this.$zendesk.setLocale(this.language)
      }
    })
  }
}
</script>

<style lang="scss" scoped>
.header-contacts {
  &__social-item {
    &:hover {
      .header-contacts__social-item-img {
        display: none;
        &.h {
          display: block;
        }
      }
    }
  }
  &__social-item-img {
    width: 25px;
    height: 25px;
    display: block;

    &.h {
      display: none;;
    }
  }
}
</style>
